import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";
import { NOTIFICATION_HEIGHT, NOTIFICATION_LIFETIME_MS, NOTIFICATION_WIDTH, notificationController } from "./NotificationController";
import { FontFamily } from "./GameUIElements";
import { DialogueParser } from "../DialogueParser";
import { findDialogSpeaker, getTextOfAction } from "../../../helper/gameActionTreeHelper";
import { gameStore } from "../../../stores/GameStore";
import { Heading1Base } from "../../shared/Heading";
import { NotificationNineSlice } from "./NineSlices";
export const countdownKeyFrames = keyframes(["from{stroke-dashoffset:0px;}to{stroke-dashoffset:", "px;}"], NOTIFICATION_HEIGHT / 100 * 226);
const StyledSvg = styled.svg.withConfig({
  displayName: "NotificationContainer__StyledSvg",
  componentId: "sc-veer08-0"
})(["width:", "px;height:", "px;transform:rotateY(-180deg) rotateZ(-90deg);"], NOTIFICATION_HEIGHT, NOTIFICATION_HEIGHT);
const StyledCircle = styled.circle.withConfig({
  displayName: "NotificationContainer__StyledCircle",
  componentId: "sc-veer08-1"
})(["stroke-dasharray:", "px;stroke-dashoffset:0px;stroke-linecap:unset;stroke-width:", "px;stroke:#CFD4DE;fill:none;animation:", " ", "ms linear forwards;"], NOTIFICATION_HEIGHT / 100 * 226, NOTIFICATION_HEIGHT / 100 * 6 * 3 + 4, countdownKeyFrames, NOTIFICATION_LIFETIME_MS);
const Container = styled.div.withConfig({
  displayName: "NotificationContainer__Container",
  componentId: "sc-veer08-2"
})(["position:absolute;display:flex;flex-direction:row;height:", "px;right:10px;", ""], NOTIFICATION_HEIGHT, FontFamily);
const ContentContainer = styled(NotificationNineSlice).withConfig({
  displayName: "NotificationContainer__ContentContainer",
  componentId: "sc-veer08-3"
})(["position:relative;top:-17px;height:", "px;display:flex;flex-direction:column;flex-shrink:0;flex-grow:1;transform:translateX(", "px);width:", "px;padding-left:4px;padding-top:4px;padding-bottom:4px;padding-right:", "px;"], NOTIFICATION_HEIGHT + 25, NOTIFICATION_HEIGHT / 2, NOTIFICATION_WIDTH - NOTIFICATION_HEIGHT / 2, NOTIFICATION_HEIGHT / 2);
const CountdownContainer = styled.div.withConfig({
  displayName: "NotificationContainer__CountdownContainer",
  componentId: "sc-veer08-4"
})(["display:flex;align-items:center;justify-content:center;background-color:#565C6E;position:relative;margin:auto;height:", "px;width:", "px;text-align:center;border-radius:", "px;border:solid black 3px;"], NOTIFICATION_HEIGHT, NOTIFICATION_HEIGHT, NOTIFICATION_HEIGHT / 2);
const CloseIcon = styled.div.withConfig({
  displayName: "NotificationContainer__CloseIcon",
  componentId: "sc-veer08-5"
})(["position:absolute;cursor:pointer;img{position:absolute;transform:translate(-50%,-50%);}"]);
const Title = styled(Heading1Base).withConfig({
  displayName: "NotificationContainer__Title",
  componentId: "sc-veer08-6"
})(["font-size:85%;position:absolute;top:-36px;left:17px;white-space:nowrap;"]);
const Text = styled.div.withConfig({
  displayName: "NotificationContainer__Text",
  componentId: "sc-veer08-7"
})(["font-size:78%;color:#CFD4DE"]);
export const NotificationContainer = observer(props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Container, {
    style: {
      top: `${props.info.topDistance}px`,
      transition: `top ${props.info.topDistance}ms cubic-bezier(.67,.86,.77,1.15)`
    },
    onClick: _ => notificationController.removeNotification(props.info.id)
  }, /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(DialogueParser, {
    dialogueString: findDialogSpeaker(props.info.action, gameStore.gameEngine.rootActionTree, t),
    initialTreeScopeContext: props.info.action
  })), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(DialogueParser, {
    dialogueString: getTextOfAction(props.info.action, props.info.extraInformation, t),
    initialTreeScopeContext: props.info.action
  }))), /*#__PURE__*/React.createElement(CountdownContainer, null, /*#__PURE__*/React.createElement(StyledSvg, null, /*#__PURE__*/React.createElement(StyledCircle, {
    r: NOTIFICATION_HEIGHT / 100 * 36,
    cx: NOTIFICATION_HEIGHT / 100 * 50 - 3,
    cy: NOTIFICATION_HEIGHT / 100 * 50
  })), /*#__PURE__*/React.createElement(CloseIcon, null, /*#__PURE__*/React.createElement("img", {
    src: "assets/game/images/UI/x-button_yellow.png"
  }), /*#__PURE__*/React.createElement("img", {
    src: "assets/game/images/UI/x_button_x.png"
  }))));
});